const T = {
  English: {
    search: 'Search for anything...',
    alerts: 'Alerts', wishlist: 'Wishlist', sell: '+ SELL',
    login: 'Login', register: 'Register', logout: 'Logout',
    my_ads: 'My Ads', my_chats: 'My Chats', settings: 'Settings',
    all_categories: '☰ ALL CATEGORIES',
    fresh_recommendations: 'Fresh recommendations',
    results_in: 'Results in', results_for: 'Results for',
    no_listings: 'No listings found. Try a different category or search.',
    ads: 'ads', view: 'View:', see_more: 'See more',
    browse_category: 'Browse by Category', total_listings: 'total listings',
    no_listings_yet: 'No listings yet',
    back_home: 'Back to Home',
    company: 'Company', help_support: 'Help & Support',
    legal: 'Legal', follow_us: 'Follow Us', region: 'Region',
    country: 'Country', language: 'Language',
    privacy_policy: 'Privacy Policy', terms: 'Terms of Use', cookies: 'Cookie Settings',
    small: 'Small', medium: 'Medium', large: 'Large', list: 'List',
    category_names: {
      'Cars': 'Cars', 'Bikes': 'Bikes', 'Properties': 'Properties',
      'Electronics & Appliances': 'Electronics & Appliances', 'Mobiles': 'Mobiles',
      'Commercial Vehicles & Spares': 'Commercial Vehicles & Spares',
      'Jobs': 'Jobs', 'Furniture': 'Furniture', 'Fashion': 'Fashion',
      'Pets': 'Pets', 'Books, Sports & Hobbies': 'Books, Sports & Hobbies', 'Services': 'Services',
    },
  },
  Hindi: {
    search: 'कुछ भी खोजें...',
    alerts: 'सूचनाएं', wishlist: 'पसंद सूची', sell: '+ बेचें',
    login: 'लॉग इन', register: 'रजिस्टर', logout: 'लॉग आउट',
    my_ads: 'मेरे विज्ञापन', my_chats: 'मेरी चैट', settings: 'सेटिंग्स',
    all_categories: '☰ सभी श्रेणियां',
    fresh_recommendations: 'नई सिफारिशें',
    results_in: 'परिणाम', results_for: 'खोज परिणाम',
    no_listings: 'कोई विज्ञापन नहीं मिला। कोई अन्य श्रेणी या खोज आज़माएं।',
    ads: 'विज्ञापन', view: 'देखें:', see_more: 'और देखें',
    browse_category: 'श्रेणी से ब्राउज़ करें', total_listings: 'कुल विज्ञापन',
    no_listings_yet: 'अभी कोई विज्ञापन नहीं',
    back_home: 'होम पर वापस जाएं',
    company: 'कंपनी', help_support: 'सहायता केंद्र',
    legal: 'कानूनी', follow_us: 'हमें फॉलो करें', region: 'क्षेत्र',
    country: 'देश', language: 'भाषा',
    privacy_policy: 'गोपनीयता नीति', terms: 'उपयोग की शर्तें', cookies: 'कुकी सेटिंग्स',
    small: 'छोटा', medium: 'मध्यम', large: 'बड़ा', list: 'सूची',
    category_names: {
      'Cars': 'कारें', 'Bikes': 'बाइक्स', 'Properties': 'संपत्तियां',
      'Electronics & Appliances': 'इलेक्ट्रॉनिक्स', 'Mobiles': 'मोबाइल',
      'Commercial Vehicles & Spares': 'वाणिज्यिक वाहन',
      'Jobs': 'नौकरियां', 'Furniture': 'फर्नीचर', 'Fashion': 'फैशन',
      'Pets': 'पालतू जानवर', 'Books, Sports & Hobbies': 'किताबें व खेल', 'Services': 'सेवाएं',
    },
  },
  Telugu: {
    search: 'ఏదైనా వెతకండి...',
    alerts: 'హెచ్చరికలు', wishlist: 'కోరిక జాబితా', sell: '+ అమ్మండి',
    login: 'లాగిన్', register: 'నమోదు', logout: 'లాగ్అవుట్',
    my_ads: 'నా ప్రకటనలు', my_chats: 'నా చాట్లు', settings: 'సెట్టింగ్లు',
    all_categories: '☰ అన్ని వర్గాలు',
    fresh_recommendations: 'తాజా సిఫార్సులు',
    results_in: 'ఫలితాలు', results_for: 'శోధన ఫలితాలు',
    no_listings: 'ప్రకటనలు కనుగొనబడలేదు. వేరొక వర్గం లేదా శోధన ప్రయత్నించండి.',
    ads: 'ప్రకటనలు', view: 'వీక్షించు:', see_more: 'మరిన్ని చూడండి',
    browse_category: 'వర్గం ద్వారా బ్రౌజ్ చేయండి', total_listings: 'మొత్తం ప్రకటనలు',
    no_listings_yet: 'ఇంకా ప్రకటనలు లేవు',
    back_home: 'హోమ్‌కు తిరిగి వెళ్ళండి',
    company: 'కంపెనీ', help_support: 'సహాయం',
    legal: 'చట్టపరమైన', follow_us: 'మమ్మల్ని అనుసరించండి', region: 'ప్రాంతం',
    country: 'దేశం', language: 'భాష',
    privacy_policy: 'గోప్యతా విధానం', terms: 'వినియోగ నిబంధనలు', cookies: 'కుకీ సెట్టింగ్లు',
    small: 'చిన్న', medium: 'మధ్యస్థ', large: 'పెద్ద', list: 'జాబితా',
    category_names: {
      'Cars': 'కార్లు', 'Bikes': 'బైక్లు', 'Properties': 'ఆస్తులు',
      'Electronics & Appliances': 'ఎలక్ట్రానిక్స్', 'Mobiles': 'మొబైల్స్',
      'Commercial Vehicles & Spares': 'వాణిజ్య వాహనాలు',
      'Jobs': 'ఉద్యోగాలు', 'Furniture': 'ఫర్నీచర్', 'Fashion': 'ఫ్యాషన్',
      'Pets': 'పెంపుడు జంతువులు', 'Books, Sports & Hobbies': 'పుస్తకాలు & క్రీడలు', 'Services': 'సేవలు',
    },
  },
  Tamil: {
    search: 'எதையும் தேடுங்கள்...',
    alerts: 'எச்சரிக்கைகள்', wishlist: 'விருப்பப் பட்டியல்', sell: '+ விற்கவும்',
    login: 'உள்நுழைய', register: 'பதிவு', logout: 'வெளியேறு',
    my_ads: 'என் விளம்பரங்கள்', my_chats: 'என் அரட்டைகள்', settings: 'அமைப்புகள்',
    all_categories: '☰ அனைத்து வகைகளும்',
    fresh_recommendations: 'புதிய பரிந்துரைகள்',
    results_in: 'முடிவுகள்', results_for: 'தேடல் முடிவுகள்',
    no_listings: 'விளம்பரங்கள் கிடைக்கவில்லை. வேறு வகை அல்லது தேடலை முயற்சிக்கவும்.',
    ads: 'விளம்பரங்கள்', view: 'காண்க:', see_more: 'மேலும் காண்க',
    browse_category: 'வகை மூலம் உலாவுங்கள்', total_listings: 'மொத்த விளம்பரங்கள்',
    no_listings_yet: 'இன்னும் விளம்பரங்கள் இல்லை',
    back_home: 'முகப்புக்கு திரும்பு',
    company: 'நிறுவனம்', help_support: 'உதவி',
    legal: 'சட்டப்பூர்வ', follow_us: 'எங்களை பின்தொடரவும்', region: 'பகுதி',
    country: 'நாடு', language: 'மொழி',
    privacy_policy: 'தனியுரிமை கொள்கை', terms: 'பயன்பாட்டு விதிமுறைகள்', cookies: 'குக்கீ அமைப்புகள்',
    small: 'சிறியது', medium: 'நடுத்தரம்', large: 'பெரியது', list: 'பட்டியல்',
    category_names: {
      'Cars': 'கார்கள்', 'Bikes': 'பைக்குகள்', 'Properties': 'சொத்துக்கள்',
      'Electronics & Appliances': 'மின்னணுவியல்', 'Mobiles': 'மொபைல்கள்',
      'Commercial Vehicles & Spares': 'வணிக வாகனங்கள்',
      'Jobs': 'வேலைகள்', 'Furniture': 'தளபாடங்கள்', 'Fashion': 'நாகரிகம்',
      'Pets': 'செல்லப்பிராணிகள்', 'Books, Sports & Hobbies': 'புத்தகங்கள் & விளையாட்டு', 'Services': 'சேவைகள்',
    },
  },
  Kannada: {
    search: 'ಏನಾದರೂ ಹುಡುಕಿ...',
    alerts: 'ಎಚ್ಚರಿಕೆಗಳು', wishlist: 'ಆಸೆ ಪಟ್ಟಿ', sell: '+ ಮಾರಿ',
    login: 'ಲಾಗಿನ್', register: 'ನೋಂದಣಿ', logout: 'ಲಾಗ್ ಔಟ್',
    my_ads: 'ನನ್ನ ಜಾಹೀರಾತುಗಳು', my_chats: 'ನನ್ನ ಚಾಟ್‌ಗಳು', settings: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    all_categories: '☰ ಎಲ್ಲಾ ವರ್ಗಗಳು',
    fresh_recommendations: 'ಹೊಸ ಶಿಫಾರಸುಗಳು',
    results_in: 'ಫಲಿತಾಂಶಗಳು', results_for: 'ಹುಡುಕಾಟ ಫಲಿತಾಂಶಗಳು',
    no_listings: 'ಯಾವುದೇ ಜಾಹೀರಾತುಗಳು ಕಂಡುಬಂದಿಲ್ಲ.',
    ads: 'ಜಾಹೀರಾತುಗಳು', view: 'ವೀಕ್ಷಿಸಿ:', see_more: 'ಇನ್ನಷ್ಟು ನೋಡಿ',
    browse_category: 'ವರ್ಗದ ಮೂಲಕ ಬ್ರೌಸ್ ಮಾಡಿ', total_listings: 'ಒಟ್ಟು ಜಾಹೀರಾತುಗಳು',
    no_listings_yet: 'ಇನ್ನೂ ಜಾಹೀರಾತುಗಳಿಲ್ಲ',
    back_home: 'ಮುಖಪುಟಕ್ಕೆ ಹಿಂತಿರುಗಿ',
    company: 'ಕಂಪನಿ', help_support: 'ಸಹಾಯ',
    legal: 'ಕಾನೂನು', follow_us: 'ನಮ್ಮನ್ನು ಅನುಸರಿಸಿ', region: 'ಪ್ರದೇಶ',
    country: 'ದೇಶ', language: 'ಭಾಷೆ',
    privacy_policy: 'ಗೌಪ್ಯತಾ ನೀತಿ', terms: 'ಬಳಕೆಯ ನಿಯಮಗಳು', cookies: 'ಕುಕೀ ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    small: 'ಚಿಕ್ಕ', medium: 'ಮಧ್ಯಮ', large: 'ದೊಡ್ಡ', list: 'ಪಟ್ಟಿ',
    category_names: {
      'Cars': 'ಕಾರುಗಳು', 'Bikes': 'ಬೈಕ್‌ಗಳು', 'Properties': 'ಆಸ್ತಿಗಳು',
      'Electronics & Appliances': 'ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್', 'Mobiles': 'ಮೊಬೈಲ್‌ಗಳು',
      'Commercial Vehicles & Spares': 'ವಾಣಿಜ್ಯ ವಾಹನಗಳು',
      'Jobs': 'ಉದ್ಯೋಗಗಳು', 'Furniture': 'ಪೀಠೋಪಕರಣ', 'Fashion': 'ಫ್ಯಾಷನ್',
      'Pets': 'ಸಾಕುಪ್ರಾಣಿಗಳು', 'Books, Sports & Hobbies': 'ಪುಸ್ತಕಗಳು & ಕ್ರೀಡೆ', 'Services': 'ಸೇವೆಗಳು',
    },
  },
  Malayalam: {
    search: 'എന്തും തിരയുക...',
    alerts: 'അലേർട്ടുകൾ', wishlist: 'ആഗ്രഹ പട്ടിക', sell: '+ വിൽക്കൂ',
    login: 'ലോഗിൻ', register: 'രജിസ്റ്റർ', logout: 'ലോഗ്ഔട്ട്',
    my_ads: 'എന്റെ പരസ്യങ്ങൾ', my_chats: 'എന്റെ ചാറ്റുകൾ', settings: 'ക്രമീകരണങ്ങൾ',
    all_categories: '☰ എല്ലാ വിഭാഗങ്ങളും',
    fresh_recommendations: 'പുതിയ ശുപാർശകൾ',
    results_in: 'ഫലങ്ങൾ', results_for: 'തിരയൽ ഫലങ്ങൾ',
    no_listings: 'ഒരു ലിസ്റ്റിംഗും കണ്ടെത്തിയില്ല.',
    ads: 'പരസ്യങ്ങൾ', view: 'കാണുക:', see_more: 'കൂടുതൽ കാണുക',
    browse_category: 'വിഭാഗം അനുസരിച്ച് ബ്രൗസ് ചെയ്യുക', total_listings: 'ആകെ ലിസ്റ്റിംഗുകൾ',
    no_listings_yet: 'ഇതുവരെ ലിസ്റ്റിംഗുകളില്ല',
    back_home: 'ഹോമിലേക്ക് മടങ്ങുക',
    company: 'കമ്പനി', help_support: 'സഹായം',
    legal: 'നിയമപരം', follow_us: 'ഞങ്ങളെ പിന്തുടരുക', region: 'പ്രദേശം',
    country: 'രാജ്യം', language: 'ഭാഷ',
    privacy_policy: 'സ്വകാര്യതാ നയം', terms: 'ഉപയോഗ നിബന്ധനകൾ', cookies: 'കുക്കി ക്രമീകരണങ്ങൾ',
    small: 'ചെറിയ', medium: 'ഇടത്തരം', large: 'വലിയ', list: 'പട്ടിക',
    category_names: {
      'Cars': 'കാറുകൾ', 'Bikes': 'ബൈക്കുകൾ', 'Properties': 'സ്വത്തുക്കൾ',
      'Electronics & Appliances': 'ഇലക്ട്രോണിക്സ്', 'Mobiles': 'മൊബൈലുകൾ',
      'Commercial Vehicles & Spares': 'വാണിജ്യ വാഹനങ്ങൾ',
      'Jobs': 'ജോലികൾ', 'Furniture': 'ഫർണിച്ചർ', 'Fashion': 'ഫാഷൻ',
      'Pets': 'വളർത്തുമൃഗങ്ങൾ', 'Books, Sports & Hobbies': 'പുസ്തകങ്ങൾ & കായികം', 'Services': 'സേവനങ്ങൾ',
    },
  },
  Bengali: {
    search: 'যেকোনো কিছু খুঁজুন...',
    alerts: 'সতর্কতা', wishlist: 'পছন্দ তালিকা', sell: '+ বিক্রি করুন',
    login: 'লগইন', register: 'নিবন্ধন', logout: 'লগ আউট',
    my_ads: 'আমার বিজ্ঞাপন', my_chats: 'আমার চ্যাট', settings: 'সেটিংস',
    all_categories: '☰ সব বিভাগ',
    fresh_recommendations: 'নতুন সুপারিশ',
    results_in: 'ফলাফল', results_for: 'অনুসন্ধান ফলাফল',
    no_listings: 'কোনো বিজ্ঞাপন পাওয়া যায়নি।',
    ads: 'বিজ্ঞাপন', view: 'দেখুন:', see_more: 'আরও দেখুন',
    browse_category: 'বিভাগ অনুসারে ব্রাউজ করুন', total_listings: 'মোট বিজ্ঞাপন',
    no_listings_yet: 'এখনো বিজ্ঞাপন নেই',
    back_home: 'হোমে ফিরুন',
    company: 'কোম্পানি', help_support: 'সহায়তা',
    legal: 'আইনি', follow_us: 'আমাদের অনুসরণ করুন', region: 'অঞ্চল',
    country: 'দেশ', language: 'ভাষা',
    privacy_policy: 'গোপনীয়তা নীতি', terms: 'ব্যবহারের শর্তাবলী', cookies: 'কুকি সেটিংস',
    small: 'ছোট', medium: 'মাঝারি', large: 'বড়', list: 'তালিকা',
    category_names: {
      'Cars': 'গাড়ি', 'Bikes': 'বাইক', 'Properties': 'সম্পত্তি',
      'Electronics & Appliances': 'ইলেকট্রনিক্স', 'Mobiles': 'মোবাইল',
      'Commercial Vehicles & Spares': 'বাণিজ্যিক যান',
      'Jobs': 'চাকরি', 'Furniture': 'আসবাবপত্র', 'Fashion': 'ফ্যাশন',
      'Pets': 'পোষা প্রাণী', 'Books, Sports & Hobbies': 'বই ও খেলাধুলা', 'Services': 'সেবা',
    },
  },
  Marathi: {
    search: 'काहीही शोधा...',
    alerts: 'सूचना', wishlist: 'इच्छा यादी', sell: '+ विका',
    login: 'लॉग इन', register: 'नोंदणी', logout: 'लॉग आउट',
    my_ads: 'माझ्या जाहिराती', my_chats: 'माझ्या गप्पा', settings: 'सेटिंग्ज',
    all_categories: '☰ सर्व श्रेणी',
    fresh_recommendations: 'नव्या शिफारशी',
    results_in: 'परिणाम', results_for: 'शोध परिणाम',
    no_listings: 'कोणत्याही जाहिराती आढळल्या नाहीत.',
    ads: 'जाहिराती', view: 'पाहा:', see_more: 'अधिक पाहा',
    browse_category: 'श्रेणीनुसार ब्राउझ करा', total_listings: 'एकूण जाहिराती',
    no_listings_yet: 'अद्याप जाहिराती नाहीत',
    back_home: 'मुख्यपृष्ठावर परत जा',
    company: 'कंपनी', help_support: 'मदत',
    legal: 'कायदेशीर', follow_us: 'आम्हाला फॉलो करा', region: 'प्रदेश',
    country: 'देश', language: 'भाषा',
    privacy_policy: 'गोपनीयता धोरण', terms: 'वापराच्या अटी', cookies: 'कुकी सेटिंग्ज',
    small: 'लहान', medium: 'मध्यम', large: 'मोठे', list: 'यादी',
    category_names: {
      'Cars': 'कार', 'Bikes': 'बाइक', 'Properties': 'मालमत्ता',
      'Electronics & Appliances': 'इलेक्ट्रॉनिक्स', 'Mobiles': 'मोबाईल',
      'Commercial Vehicles & Spares': 'व्यावसायिक वाहने',
      'Jobs': 'नोकऱ्या', 'Furniture': 'फर्निचर', 'Fashion': 'फॅशन',
      'Pets': 'पाळीव प्राणी', 'Books, Sports & Hobbies': 'पुस्तके व खेळ', 'Services': 'सेवा',
    },
  },
  Gujarati: {
    search: 'કઈ પણ શોધો...',
    alerts: 'ચેતવણીઓ', wishlist: 'ઈચ્છા યાદી', sell: '+ વેચો',
    login: 'લૉગ ઇન', register: 'નોંધણી', logout: 'લૉગ આઉટ',
    my_ads: 'મારી જાહેરાતો', my_chats: 'મારી ચેટ', settings: 'સેટિંગ્સ',
    all_categories: '☰ બધી શ્રેણીઓ',
    fresh_recommendations: 'નવી ભલામણો',
    results_in: 'પરિણામો', results_for: 'શોધ પરિણામો',
    no_listings: 'કોઈ જાહેરાત મળી નથી.',
    ads: 'જાહેરાતો', view: 'જુઓ:', see_more: 'વધુ જુઓ',
    browse_category: 'શ્રેણી અનુસાર બ્રાઉઝ કરો', total_listings: 'કુલ જાહેરાતો',
    no_listings_yet: 'હજી સુધી જાહેરાત નથી',
    back_home: 'હોમ પર પાછા જાઓ',
    company: 'કંપની', help_support: 'સહાય',
    legal: 'કાનૂની', follow_us: 'અમને ફૉલો કરો', region: 'પ્રદેશ',
    country: 'દેશ', language: 'ભાષા',
    privacy_policy: 'ગોપનીયતા નીતિ', terms: 'ઉપયોગ શરતો', cookies: 'કૂકી સેટિંગ્સ',
    small: 'નાનો', medium: 'મધ્યમ', large: 'મોટો', list: 'યાદી',
    category_names: {
      'Cars': 'કાર', 'Bikes': 'બાઇક', 'Properties': 'મિલકત',
      'Electronics & Appliances': 'ઈલેક્ટ્રોનિક્સ', 'Mobiles': 'મોબાઈલ',
      'Commercial Vehicles & Spares': 'વ્યાપારી વાહનો',
      'Jobs': 'નોકરીઓ', 'Furniture': 'ફર્નિચર', 'Fashion': 'ફૅશન',
      'Pets': 'પાળતુ પ્રાણી', 'Books, Sports & Hobbies': 'પુસ્તકો અને રમત', 'Services': 'સેવાઓ',
    },
  },
  Punjabi: {
    search: 'ਕੁਝ ਵੀ ਲੱਭੋ...',
    alerts: 'ਸੂਚਨਾਵਾਂ', wishlist: 'ਚਾਹਤ ਸੂਚੀ', sell: '+ ਵੇਚੋ',
    login: 'ਲੌਗ ਇਨ', register: 'ਰਜਿਸਟਰ', logout: 'ਲੌਗ ਆਊਟ',
    my_ads: 'ਮੇਰੇ ਇਸ਼ਤਿਹਾਰ', my_chats: 'ਮੇਰੀਆਂ ਚੈਟਾਂ', settings: 'ਸੈਟਿੰਗਜ਼',
    all_categories: '☰ ਸਾਰੀਆਂ ਸ਼੍ਰੇਣੀਆਂ',
    fresh_recommendations: 'ਨਵੀਆਂ ਸਿਫ਼ਾਰਿਸ਼ਾਂ',
    results_in: 'ਨਤੀਜੇ', results_for: 'ਖੋਜ ਨਤੀਜੇ',
    no_listings: 'ਕੋਈ ਇਸ਼ਤਿਹਾਰ ਨਹੀਂ ਮਿਲਿਆ।',
    ads: 'ਇਸ਼ਤਿਹਾਰ', view: 'ਦੇਖੋ:', see_more: 'ਹੋਰ ਦੇਖੋ',
    browse_category: 'ਸ਼੍ਰੇਣੀ ਅਨੁਸਾਰ ਬ੍ਰਾਊਜ਼ ਕਰੋ', total_listings: 'ਕੁੱਲ ਇਸ਼ਤਿਹਾਰ',
    no_listings_yet: 'ਅਜੇ ਕੋਈ ਇਸ਼ਤਿਹਾਰ ਨਹੀਂ',
    back_home: 'ਘਰ ਵੱਲ ਵਾਪਸ ਜਾਓ',
    company: 'ਕੰਪਨੀ', help_support: 'ਸਹਾਇਤਾ',
    legal: 'ਕਾਨੂੰਨੀ', follow_us: 'ਸਾਨੂੰ ਫੋਲੋ ਕਰੋ', region: 'ਖੇਤਰ',
    country: 'ਦੇਸ਼', language: 'ਭਾਸ਼ਾ',
    privacy_policy: 'ਗੋਪਨੀਯਤਾ ਨੀਤੀ', terms: 'ਵਰਤੋਂ ਦੀਆਂ ਸ਼ਰਤਾਂ', cookies: 'ਕੂਕੀ ਸੈਟਿੰਗਜ਼',
    small: 'ਛੋਟਾ', medium: 'ਦਰਮਿਆਨਾ', large: 'ਵੱਡਾ', list: 'ਸੂਚੀ',
    category_names: {
      'Cars': 'ਕਾਰਾਂ', 'Bikes': 'ਬਾਈਕ', 'Properties': 'ਜਾਇਦਾਦ',
      'Electronics & Appliances': 'ਇਲੈਕਟ੍ਰਾਨਿਕਸ', 'Mobiles': 'ਮੋਬਾਈਲ',
      'Commercial Vehicles & Spares': 'ਵਪਾਰਕ ਵਾਹਨ',
      'Jobs': 'ਨੌਕਰੀਆਂ', 'Furniture': 'ਫਰਨੀਚਰ', 'Fashion': 'ਫੈਸ਼ਨ',
      'Pets': 'ਪਾਲਤੂ ਜਾਨਵਰ', 'Books, Sports & Hobbies': 'ਕਿਤਾਬਾਂ ਅਤੇ ਖੇਡਾਂ', 'Services': 'ਸੇਵਾਵਾਂ',
    },
  },
  Urdu: {
    search: 'کچھ بھی تلاش کریں...',
    alerts: 'اطلاعات', wishlist: 'خواہش فہرست', sell: '+ فروخت کریں',
    login: 'لاگ ان', register: 'رجسٹر', logout: 'لاگ آؤٹ',
    my_ads: 'میرے اشتہارات', my_chats: 'میری چیٹس', settings: 'ترتیبات',
    all_categories: '☰ تمام اقسام',
    fresh_recommendations: 'نئی سفارشات',
    results_in: 'نتائج', results_for: 'تلاش نتائج',
    no_listings: 'کوئی اشتہار نہیں ملا۔',
    ads: 'اشتہارات', view: 'دیکھیں:', see_more: 'مزید دیکھیں',
    browse_category: 'زمرے کے مطابق براؤز کریں', total_listings: 'کل اشتہارات',
    no_listings_yet: 'ابھی تک اشتہارات نہیں',
    back_home: 'ہوم پر واپس جائیں',
    company: 'کمپنی', help_support: 'مدد',
    legal: 'قانونی', follow_us: 'ہمیں فالو کریں', region: 'علاقہ',
    country: 'ملک', language: 'زبان',
    privacy_policy: 'رازداری کی پالیسی', terms: 'استعمال کی شرائط', cookies: 'کوکی ترتیبات',
    small: 'چھوٹا', medium: 'درمیانہ', large: 'بڑا', list: 'فہرست',
    category_names: {
      'Cars': 'گاڑیاں', 'Bikes': 'بائیک', 'Properties': 'جائیداد',
      'Electronics & Appliances': 'الیکٹرونکس', 'Mobiles': 'موبائل',
      'Commercial Vehicles & Spares': 'تجارتی گاڑیاں',
      'Jobs': 'ملازمتیں', 'Furniture': 'فرنیچر', 'Fashion': 'فیشن',
      'Pets': 'پالتو جانور', 'Books, Sports & Hobbies': 'کتابیں اور کھیل', 'Services': 'خدمات',
    },
  },
  Odia: {
    search: 'ଯେକୌଣସି କିଛି ଖୋଜନ୍ତୁ...',
    alerts: 'ସତର୍କତା', wishlist: 'ଇଚ୍ଛା ତାଲିକା', sell: '+ ବିକ୍ରୟ କରନ୍ତୁ',
    login: 'ଲଗ ଇନ', register: 'ପଞ୍ଜୀକରଣ', logout: 'ଲଗ ଆଉଟ',
    my_ads: 'ମୋ ବିଜ୍ଞାପନ', my_chats: 'ମୋ ଚ୍ୟାଟ', settings: 'ସେଟିଂ',
    all_categories: '☰ ସମସ୍ତ ବର୍ଗ',
    fresh_recommendations: 'ନୂଆ ସୁପାରିଶ',
    results_in: 'ଫଳାଫଳ', results_for: 'ଖୋଜ ଫଳାଫଳ',
    no_listings: 'କୌଣସି ବିଜ୍ଞାପନ ମିଳିଲା ନାହିଁ।',
    ads: 'ବିଜ୍ଞାପନ', view: 'ଦେଖନ୍ତୁ:', see_more: 'ଆଉ ଦେଖନ୍ତୁ',
    browse_category: 'ବର୍ଗ ଅନୁସାରେ ବ୍ରାଉଜ କରନ୍ତୁ', total_listings: 'ମୋଟ ବିଜ୍ଞାପନ',
    no_listings_yet: 'ଏପର୍ଯ୍ୟନ୍ତ ବିଜ୍ଞାପନ ନାହିଁ',
    back_home: 'ହୋମ୍ ଫେରି ଯାଆନ୍ତୁ',
    company: 'କମ୍ପାନୀ', help_support: 'ସାହାଯ୍ୟ',
    legal: 'ଆଇନ', follow_us: 'ଆମକୁ ଅନୁସରଣ କରନ୍ତୁ', region: 'ଅଞ୍ଚଳ',
    country: 'ଦେଶ', language: 'ଭାଷା',
    privacy_policy: 'ଗୋପନୀୟତା ନୀତି', terms: 'ବ୍ୟବହାରର ସର୍ତ୍ତ', cookies: 'କୁକି ସେଟିଂ',
    small: 'ଛୋଟ', medium: 'ମଧ୍ୟମ', large: 'ବଡ', list: 'ତାଲିକା',
    category_names: {
      'Cars': 'କାର', 'Bikes': 'ବାଇକ', 'Properties': 'ସମ୍ପତ୍ତି',
      'Electronics & Appliances': 'ଇଲେକ୍ଟ୍ରୋନିକ୍ସ', 'Mobiles': 'ମୋବାଇଲ',
      'Commercial Vehicles & Spares': 'ବ୍ୟବସାୟିକ ଯାନ',
      'Jobs': 'ଚାକିରି', 'Furniture': 'ଆସବାବପତ୍ର', 'Fashion': 'ଫ୍ୟାଶନ',
      'Pets': 'ଘରୋଇ ଜୀବ', 'Books, Sports & Hobbies': 'ବହି ଓ କ୍ରୀଡ଼ା', 'Services': 'ସେବା',
    },
  },
};

export function t(lang, key) {
  const langData = T[lang] || T['English'];
  return langData[key] || T['English'][key] || key;
}

export function tCat(lang, catName) {
  const langData = T[lang] || T['English'];
  return (langData.category_names && langData.category_names[catName]) || catName;
}

export default T;
